import React from "react";
import "./placeholder.scss";

const Placeholder = ({ icon, text, type }) => (
  <figure className={`ph${type ? `--${type}` : ""}`}>
    {icon && <span className={`ph__icon ${icon}`}></span>}
    <span className='ph__text'>{text}</span>
  </figure>
);

export default Placeholder;
